<div id="navbar-tabs">
  <mat-tab-group>

    <mat-tab label="Fuentes">

      <mat-form-field class="mat-form-field-appearance-legacy-search">
        <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Buscar">
      </mat-form-field>

      <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" matSort matSortActive="data" matSortDirection="desc" matSortDisableClear="true">
        <caption>Fuentes</caption>
        <ng-container matColumnDef="name">
          <th scope="col" mat-header-cell *matHeaderCellDef> </th>
          <td mat-cell *matCellDef="let element"> {{element.name}} </td>
        </ng-container>

        <ng-container matColumnDef="fav">
          <th scope="col" mat-header-cell *matHeaderCellDef> </th>
          <td mat-cell *matCellDef="let element">
            <em (click)="favorite(element)" [ngClass]="element.clicked  ? 'isFav' : 'isNotFav'" class="fa fa-star"
            aria-hidden="true"></em>
          </td>
        </ng-container>

        <ng-container matColumnDef="data">
          <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header></th>
          <td mat-cell *matCellDef="let element"> <span matBadge={{element.data}} matBadgeOverlap="false">
          </span></td>
        </ng-container>

        <ng-container matColumnDef="vig">
          <th scope="col" mat-header-cell *matHeaderCellDef> </th>
          <td mat-cell *matCellDef="let element">
            @if (element.vig) {
              <span><i class="fa fa-exclamation-circle vigente" aria-hidden="true"></i></span>
            }
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

      </table>

    </mat-tab>

  </mat-tab-group>
</div>